// src/components/settings/LanguageSettings.js
import React, { useState, useEffect } from "react";

function LanguageSettings() {
  const [language, setLanguage] = useState("en");
  const [status, setStatus] = useState("");

  useEffect(() => {
    // Note: Language settings endpoint doesn't exist in the DB API collection
    // This would need to be implemented in the backend
    console.warn("Language settings API not available in current DB API collection");
    setLanguage("en"); // Default fallback
  }, []);

  const handleSave = () => {
    // Note: Language settings endpoint doesn't exist in the DB API collection
    console.warn("Language settings save not implemented in API");
    setStatus("Language settings API not available yet.");
  };

  return (
    <div>
      <h3>Preferred Language</h3>
      <select value={language} onChange={(e) => setLanguage(e.target.value)}>
        <option value="en">English</option>
        <option value="es">Spanish</option>
        <option value="fr">French</option>
      </select>
      <button onClick={handleSave}>Save</button>
      {status && <p>{status}</p>}
    </div>
  );
}

export default LanguageSettings;
